import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function MissingSpeedIndex({ onClick }) {
    return (
        <div className="statusbar-mobile__missing-status statusbar-mobile__missing-status--postcode">
            <Translations translationKey="catalog-missing-status-load-index-hint" />
            {' '}
            <Translations
                translationKey="catalog-statusbar-mobile-missing-status-speed-index"
                className="statusbar-mobile__missing-status-action-text"
                onClick={onClick}
            />
        </div>
    );
}

MissingSpeedIndex.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { MissingSpeedIndex };
